import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: () => {
        window.location.href = '/main.html'
        return '/'  // 폴백 경로
      }
    },
    { path: '/admin', meta: {authorized: true}, children: [
          { path: '/admin/version', name: 'version', component: () => import('@/views/admin/version/Version.vue') }
      ]
    },
    { path: '/usecase', meta: {authorized: true}, children: [
        { path: '/usecase/cdt-action-buttons', component: () => import('@/views/guide/Usecase-CDTActionButtons.vue') },
        { path: '/usecase/cdt-pagination', component: () => import('@/views/guide/Usecase-CDTPagination.vue') },
        { path: '/usecase/cdt-modal', component: () => import('@/views/guide/Usecase-CDTModal.vue') },
        { path: '/usecase/cdt-background', component: () => import('@/views/guide/Usecase-CDTBackgroundImg.vue') },
        { path: '/usecase/cdt-time-dial', component: () => import('@/views/guide/Usecase-CDTTimeDial.vue') }
      ]
    }
  ],
});

export default router;
